import { create } from 'zustand'
import { profileApi } from '../services/profileApi'
import useAppStore from '../../../store/useAppStore'

let loadRequestId = 0

export const useAchievementsStore = create((set, get) => ({
  achievements: null,
  isLoading: false,
  isSaving: false,
  error: null,

  loadAchievements: async (slug, language) => {
    const requestId = ++loadRequestId
    const revision = useAppStore.getState().languageRevision
    set({ achievements: null, isLoading: true, error: null })

    const { ok, status, data } = slug
      ? await profileApi.getProfileAchievements(slug, language)
      : await profileApi.getMyAchievements()

    if (requestId !== loadRequestId || revision !== useAppStore.getState().languageRevision) return

    if (status === 404) {
      set({ isLoading: false, error: 'not_found' })
      return
    }
    if (status === 429) {
      set({ isLoading: false, error: 'rate_limited' })
      return
    }

    if (!ok || !data?.achievements) {
      set({ isLoading: false, error: 'load_error' })
      return
    }

    set({ achievements: data.achievements, isLoading: false })
  },

  saveShowcase: async (codes) => {
    if (get().isSaving) return null
    set({ isSaving: true })

    const { ok, status, data } = await profileApi.setAchievementShowcase(codes)
    set({ isSaving: false })

    if (!ok || !Array.isArray(data?.showcase)) {
      return { ok: false, status, error: data?.error }
    }

    const achievements = get().achievements
    set({
      achievements: {
        ...achievements,
        showcase: data.showcase.map((achievement) => achievement.code),
        showcase_custom: data.showcase_custom
      }
    })

    return { ok: true, showcase: data.showcase, showcaseCustom: data.showcase_custom }
  },

  reset: () => {
    loadRequestId += 1
    set({ achievements: null, isLoading: false, isSaving: false, error: null })
  }
}))
